import React, { useState, useEffect } from "react";

interface JobDescriptionEditorProps {
  initialContent?: string;
  onContentChange: (content: string) => void;
  className?: string;
  placeholder?: string;
}

const JobDescriptionEditor: React.FC<JobDescriptionEditorProps> = ({
  initialContent = "",
  onContentChange,
  className = "",
  placeholder = "Enter or paste job description text here..."
}) => {
  const [content, setContent] = useState(initialContent);

  // Update content when initialContent changes
  useEffect(() => {
    if (initialContent !== content) {
      setContent(initialContent);
    }
  }, [initialContent]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newContent = e.target.value;
    setContent(newContent);
    onContentChange(newContent);
  };

  return (
    <div className={`w-full ${className}`}>
      <textarea
        value={content}
        onChange={handleChange}
        placeholder={placeholder}
        className="w-full h-[550px] p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none font-mono text-sm"
      />
    </div>
  );
};

export default JobDescriptionEditor;
